module.exports = __webpack_public_path__ + "static/seres-silk-duvet-1-thumbnail-f7d6844c8d105f6115da0d11a3a2f868.png";